import "reflect-metadata";
import { container } from "tsyringe";
import { App } from "./app";
import { PixiApp } from "./pixi-app";

// probably fix for initial interaction bug, when there is not pointers
container.resolve(PixiApp).render();
const app = container.resolve(App);
app.run();

// @ts-ignore
if (module.hot) {
  // @ts-ignore
  module.hot.accept(() => window.location.reload());
}
